import { useEffect, useRef, useState } from "react";
import { useAuthStore } from "@/store/useAuthStore";
import { isTeacher } from "@/utils/role-utils";
import {
  renderMathElements,
  attachAnswerToggles,
  parseHtmlForRender,
} from "@ever-tutor/et-ui";

export default function SlideViewerPage() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [slideHtml, setSlideHtml] = useState("");
  const [slideStyles, setSlideStyles] = useState("");
  const [error, setError] = useState("");
  const user = useAuthStore((s) => s.user);
  const showAnswerToggle = isTeacher(user?.role);

  const url = new URLSearchParams(window.location.search).get("url");

  useEffect(() => {
    if (!url) {
      setError("No URL provided");
      return;
    }
    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then((html) => {
        const parsed = parseHtmlForRender(html);
        if (!parsed) {
          setError("No slide content found");
          return;
        }
        setSlideStyles(parsed.styles);
        setSlideHtml(parsed.slideHtml);
      })
      .catch((e) => setError(String(e)));
  }, [url]);

  useEffect(() => {
    if (!slideHtml || !containerRef.current) return;
    const container = containerRef.current;
    renderMathElements(container);
    // Wait for layout before measuring rects
    requestAnimationFrame(() => {
      container.querySelectorAll("[data-answer-toggle]").forEach((el) => el.remove());
      attachAnswerToggles(container, container, showAnswerToggle);
    });
  }, [slideHtml, showAnswerToggle]);

  if (error)
    return <div style={{ padding: 16, color: "red" }}>Error: {error}</div>;
  if (!slideHtml) return null;

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "white",
      }}
    >
      {slideStyles && <div dangerouslySetInnerHTML={{ __html: slideStyles }} />}
      <div
        ref={containerRef}
        style={{
          position: "relative",
          width: 960,
          height: 700,
          overflow: "hidden",
        }}
        dangerouslySetInnerHTML={{ __html: slideHtml }}
      />
    </div>
  );
}
